module.exports = __webpack_public_path__ + "img/vallendeman_wolkjes_600x600px.44c9e87f.png";